import {
  GetAssetVersionTasksLastReadSuccessDto,
  TaskControllerGetAssetVersionTasksLastReadParams
} from '@api/Api';
import { taskGetAssetVersionTasksLastRead } from '@api/Task';
import { useQuery } from '@tanstack/react-query';

export const QUERY_TASKS_LAST_READ = 'tasks_last_read';

export function useAssetVersionTasksLastReadQuery(
  params: TaskControllerGetAssetVersionTasksLastReadParams,
  options?: {
    enabled?: boolean;
  }
) {
  const queryKey = [QUERY_TASKS_LAST_READ, params.assetVersionId];
  return useQuery<GetAssetVersionTasksLastReadSuccessDto>({
    ...(options ?? {}),
    queryKey,
    queryFn: async ({ signal }) => {
      const { data } = await taskGetAssetVersionTasksLastRead(params, {
        signal
      });
      return data;
    }
  });
}
